var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-footer',{attrs:{"padless":"","app":"","color":"grey lighten-2"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("S.d.S. s.r.l.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }